/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useEffect, useState, useRef } from 'react';

export default function useClickAway() {
    const [active, setActive] = useState(false);

    const ref = useRef(null);
    function toggle() {
        setActive(!active);
    }
    function handleClick(e) {
        if (ref?.current && !ref.current.contains(e.target)) {
            if (e.target?.childElementCount === 1 && e.target?.getAttribute?.('data-action') !== 'expansion'  && e.target?.parentElement?.getAttribute?.('data-action') !== 'expansion') {
                setActive(false);
            }
        }
    }

    useEffect(() => {
        if (active) document.addEventListener('mousedown', handleClick);
        else document.removeEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);
    return {
        ref, active, setActive, toggle,
    };
}
